/**
 * Styles for CreateNewActionPlan
 */

import { StyleSheet, Platform } from 'react-native';

export const styles = StyleSheet.create({
  page: {
    flex: 1,
    paddingVertical: 24,
    paddingHorizontal: Platform.OS === 'web' ? 24 : 16,
    backgroundColor: '#F5F9FF',
  },
  scrollContent: {
    alignItems: 'center',
    paddingBottom: 24,
  },
  formWrapper: {
    width: Platform.OS === 'web' ? '70%' : '100%',
    maxWidth: 900,
    alignSelf: 'flex-start',
    paddingLeft: Platform.OS === 'web' ? 16 : 0,
  },
  headerWrapper: {
    display: 'flex',
    width: Platform.OS === 'web' ? '70%' : '100%',
    maxWidth: 900,
    alignSelf: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginBottom: 24,
    marginTop: 0,
  },
  heading: {
    color: '#2D2D2D',
    ...(Platform.OS === 'web' ? { fontFeatureSettings: "'liga' 0, 'clig' 0" } : {}),
    fontFamily: 'Inter',
    fontSize: Platform.OS === 'web' ? 28 : 24,
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 40,
    paddingLeft: Platform.OS === 'web' ? 16 : 0,
  } as any,
});
